var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterUsdDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3869_85022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0824C0.142445 11.6303 1.45621 12.7288 3.45621 12.8709V14H4.46006V12.8709C6.64485 12.7046 8 11.5356 8 9.80657C8 8.33014 7.08855 7.47586 5.15496 6.99486L4.46006 6.82121V3.29079C5.53994 3.39293 6.26853 3.95379 6.45236 4.79136H7.86718C7.70741 3.30564 6.38498 2.23964 4.46006 2.12171V1H3.45621V2.14493C1.58999 2.3585 0.308951 3.51179 0.308951 5.0755C0.308951 6.42564 1.23869 7.38114 2.87007 7.78414L3.45717 7.93457V11.6776C2.3513 11.5198 1.58999 10.9348 1.40616 10.0824H0ZM3.26371 6.52036C2.25987 6.27614 1.72377 5.75429 1.72377 5.01979C1.72377 4.14321 2.40135 3.496 3.45621 3.32236V6.56771L3.26371 6.52129V6.52036ZM4.795 8.25864C6.03369 8.55857 6.57748 9.05629 6.57748 9.90129C6.57748 10.9199 5.78248 11.5987 4.46006 11.7018V8.17786L4.795 8.25771V8.25864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4997 2.74933C12.5992 2.74933 12.6946 2.78884 12.7649 2.85916C12.8352 2.92949 12.8747 3.02487 12.8747 3.12433V11.9691L15.2342 9.60883C15.3047 9.53841 15.4002 9.49886 15.4997 9.49886C15.5993 9.49886 15.6948 9.53841 15.7652 9.60883C15.8357 9.67924 15.8752 9.77475 15.8752 9.87433C15.8752 9.97391 15.8357 10.0694 15.7652 10.1398L12.7652 13.1398C12.7304 13.1748 12.689 13.2025 12.6435 13.2214C12.5979 13.2403 12.5491 13.25 12.4997 13.25C12.4504 13.25 12.4016 13.2403 12.356 13.2214C12.3105 13.2025 12.2691 13.1748 12.2342 13.1398L9.23424 10.1398C9.19938 10.105 9.17172 10.0636 9.15285 10.018C9.13398 9.97246 9.12427 9.92364 9.12427 9.87433C9.12427 9.77475 9.16383 9.67924 9.23424 9.60883C9.30466 9.53841 9.40016 9.49886 9.49974 9.49886C9.59932 9.49886 9.69483 9.53841 9.76524 9.60883L12.1247 11.9691V3.12433C12.1247 3.02487 12.1643 2.92949 12.2346 2.85916C12.3049 2.78884 12.4003 2.74933 12.4997 2.74933Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3869_85022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUsdDescIcon);
export default __webpack_public_path__ + "static/media/filter-usd-desc-icon.8179ce5419c30a9313f3c6a6482b588b.svg";
export { ForwardRef as ReactComponent };